import { isTimeWithinRange } from "../utils/isTimeWithinRange/isTimeWithinRange";

export function disableTimeOptionOutsideOfAllowedTimeRange(params: {
  timeOption: {
    value: { hour: number; minute: number };
    text: string;
    disabled: boolean;
  };
  allowedTimeRange?: {
    start: { hour: number; minute: number };
    end: { hour: number; minute: number };
  };
}): {
  value: { hour: number; minute: number };
  text: string;
  disabled: boolean;
} {
  const { timeOption, allowedTimeRange } = params;
  if (!allowedTimeRange?.start || !allowedTimeRange?.end) {
    return timeOption;
  }

  if (
    isTimeWithinRange({
      timeToCheck: timeOption.value,
      start: allowedTimeRange.start,
      end: allowedTimeRange.end,
    })
  ) {
    return timeOption;
  }

  return { ...timeOption, disabled: true };
}
